function getMenuEntries(site, actualPath) {
  const actualPage = site.find(p => p.path === actualPath)
  const actualSuffix = (actualPage && actualPage.suffix) || ''

  const pagesWithoutSuffix = site.filter(
    p => p.suffix === null || p.suffix === ''
  )
  const root = []

  // Recursive function with mutable arrays to create tree with children
  function getOrCreateEntry(a, path, page, level = 0) {
    if (path.length > 1) {
      let parent = a.find(({ p }) => p === path[0])
      if (!parent) {
        parent = {
          ...page,
          p: path[0],
          children: [],
          level,
          title: level === 0 ? page.rootTitle || page.title : page.parentTitle,
        }
        a.push(parent)
      }
      getOrCreateEntry(parent.children, path.slice(1), page, level + 1)
    } else {
      a.push({
        ...page,
        p: path[0],
        children: [],
        level,
        title: (level === 0 && page.rootTitle) || page.title,
      })
    }
  }

  for (const page of pagesWithoutSuffix) {
    const splitPath = page.path.split('/').slice(1)
    getOrCreateEntry(root, splitPath, page)
  }

  function addSuffixRecursively(a, suffix) {
    a.forEach(page => {
      if (page.suffix === '') {
        page.path += actualSuffix
      }
      if (page.children.length) {
        addSuffixRecursively(page.children)
      }
    })
  }
  addSuffixRecursively(root, actualSuffix)

  function markActivePath(a, path) {
    const parent = a.find(({ p }) => p === path[0])
    if (parent) {
      parent.active = true
      if (parent.children.length) {
        markActivePath(parent.children, path.slice(1))
      }
    }
  }
  markActivePath(root, actualPath.split('/').slice(1))

  function replaceInactiveChildren(a) {
    a.forEach(parent => {
      if (!parent.active) {
        parent.children = parent.children.length > 0 ? true : false
      } else {
        replaceInactiveChildren(parent.children)
      }
    })
  }
  replaceInactiveChildren(root)

  return root
}

export default getMenuEntries



// WEBPACK FOOTER //
// ./src/layouts/getMenuEntries.js